import IconQuickApplyLocation from './resources/icon-location.svg';
import IconQuickApplyExperience from './resources/icon-experience.svg';
import IconQuickApplyLightningOrange from './resources/icon-lightning-orange.svg';
import IconQuickApplyLightningWhite from './resources/icon-lightning-white.svg';
import IconQuickApplySend from './resources/icon-send-white.svg';
import IconQuickApplyLock from './resources/icon-lock.svg';
import IconQuickApplyCheckCircle from './resources/icon-check-circle.svg';
import IconQuickApplySearch from './resources/icon-search-green.svg';
import IconQuickApplyArrowRight from './resources/icon-arrow-right-white.svg';
import IconQuickApplyEye from './resources/icon-eye-orange.svg';
import IconQuickApplyStar from './resources/icon-star-orange.svg';
import IconQuickApplyCheck from './resources/icon-check.svg';
import IconQuickApplyPerson from './resources/icon-person.svg';
import IconQuickApplyCompany from './resources/icon-company.svg';
import IconCallConsentBoth from './resources/icon-call-consent-both.svg';
import IconCallConsentTick from './resources/icon-call-consent-tick.svg';
import IconQuickApplyDesignation from './resources/icon-designation.svg';
import IconQuickApplyCalendar from './resources/icon-calendar.svg';
import IconQuickApplyRupee from './resources/icon-rupee.svg';
import IconQuickApplyAboutRole from './resources/icon-about-role.svg';
import IconQuickApplyResponsibilities from './resources/icon-responsibilities.svg';
import IconQuickApplyQualifications from './resources/icon-qualifications.svg';
import IconQuickApplyPreferred from './resources/icon-preferred.svg';
import IconQuickApplyLightningGreen from './resources/icon-lightning-green.svg';
import IconQuickApplyEyeGreen from './resources/icon-eye-green.svg';
import IconQuickApplyStarGreen from './resources/icon-star-green.svg';
import YellowCrown from './resources/premium.svg';
import Users from './resources/people.svg';
import DefaultJobLogo from './resources/confirm-and-apply.svg';
import ChevronUp from './resources/chevron-up.svg';
import ChevronDown from './resources/chevron-down.svg';
import ChevronDownLight from './resources/chevron-down-light.svg';
import ChevronRight from './resources/ch-right.svg';
import ChevronLeft from './resources/chevron-left.svg';
import Filter from './resources/filter.svg';
import Search from './resources/search.svg';
import Check from './resources/check.svg';
import CheckCircle from './resources/circle.svg';
import Cross from './resources/cross.svg';
import Women from './resources/women2.svg';
import WomenProfessional from './resources/women.svg';
import DifferentlyAbled from './resources/differently_abled.svg';
import Home from './resources/home.svg';
import Medal from './resources/medal.svg';
import Docs from './resources/docs.svg';
import CrossOutlined from './resources/cross_outlined.svg';
import WhiteCrossOutlined from './resources/white-cross-outline.svg';
import HamburgerMenu from './resources/hamburger-menu.svg';
import Send from './resources/send.svg';
import Logout from './resources/logout.svg';
import Notification from './resources/notification.svg';
import Message from './resources/message.svg';
import Edit from './resources/edit.svg';
import Video from './resources/video.svg';
import Eye from './resources/eye.svg';
import HiddenEye from './resources/eye-hide.svg';
import CheckIcon from './resources/checkIcon.svg';
import CheckedOrange from './resources/checked_orange.svg';
import UnCheckIcon from './resources/unCheckIcon.svg';
import HashTag from './resources/hashtag.svg';
import EmptyJob from './resources/emptyJob.svg';
import CrossWhite from './resources/cross_white.svg';
import Categorize from './resources/categorize.svg';
import ThumbUp from './resources/thumb-up.svg';
import DrawerClose from './resources/drawer_close.svg';
import LeftArrow from './resources/leftArrow.svg';
import Dot from './resources/dot.svg';
import RoundedStar from './resources/rounded-star.svg';
import BankingFinanceJobs from './resources/banking-finance-jobs.svg';
import AIJobs from './resources/ai-jobs.svg';
import SalesMarketingJobs from './resources/sale-marketing-jobs.svg';
import ConsultingJobs from './resources/consulting-jobs.svg';
import HRIRJobs from './resources/hr-ir-jobs.svg';
import ITSystemJobs from './resources/it-system-jobs.svg';
import Calender from './resources/calender.svg';
import SCMOperationJobs from './resources/scm-ops-jobs.svg';
import LegalJobs from './resources/legal-jobs.svg';
import BPOJobs from './resources/bpo-jobs.svg';
import SearchIcon from './resources/search-icon.svg';
import CheckedHirist from './resources/checked.svg';
import GoUpIcon from './resources/go-up-icon.svg';
import CautionIcon from './resources/caution.svg';
import BgImage from './resources/Bg.svg';
import ThreeDotMenuIcon from './resources/three-dot-menu.svg';
import StarIcon from './resources/star.svg';
import RadioSelected from './resources/radio-select.svg';
import RadioUnSelected from './resources/radio.svg';
import IimjobsLogo from './resources/Iimjobs-logo.svg';
import IimjobsLogoOutlined from './resources/Iimjobs-logo-outlined.svg';
import WebBrowserLogo from './resources/web-browser-logo.svg';
import Survey from './resources/survey.svg';
import SurveyBackground from './resources/survey-background.svg';
import SurveyCheck from './resources/survey-check.svg';
import ThumbsUpYellow from './resources/thumbs-up-yellow.svg';
import ThumbsDownGrey from './resources/thumbs-down-grey.svg';
import CrossOutlineWhite from './resources/cross-outline-white.svg';
import AddOutlineBlack from './resources/add-outline-black.svg';
import GreenBag from './resources/green-bag.svg';
import ThumbsUpGreen from './resources/thumbs-up-green.svg';
import SurveyCheckGreen from './resources/survey-check-green.svg';
import OutlineCicleCheck from './resources/outlined-circle-check.svg';
import OutlineCircleCross from './resources/outlined-circle-cross.svg';
import WrongCircle from './resources/wrong.svg';
import NoJobSaved from './resources/no_jobs_saved.svg';
import NoNotificationBanner from './resources/no-notifications.svg';
import LinkedIn from './resources/linkedin.svg';
import Facebook from './resources/facebook.svg';
import Twitter from './resources/twitter.svg';
import Minus from './resources/minus.svg';
import Plus from './resources/plus.svg';
import videoOverlayIcon from './resources/video-overlay-icon.svg';
import audio from './resources/audio.svg';
import video from './resources/play.svg';
import Download from './resources/download.svg';
import HiristDownload from './resources/download-1.svg';
import Mumbai from './resources/mumbai.svg';
import Pune from './resources/pune.svg';
import TickBox from './resources/tickbox.svg';
import Thread from './resources/thread.svg';
import HTick from './resources/hiristTick.svg';
import Bengaluru from './resources/bengaluru.svg';
import LineDivider from './resources/divider.svg';
import Chennai from './resources/chennai.svg';
import Kolkata from './resources/kolkata.svg';
import DelhiNCR from './resources/delhincr.svg';
import Hyderabad from './resources/hyderabad.svg';
import WhiteChevronRight from './resources/WhiteChevronRight.svg';
import MinusBlack from './resources/MinusBlack.svg';
import Scope from './resources/scope.svg';
import HiristMan from './resources/hirist-man.svg';
import HiristWoman from './resources/hirist-women.svg';
import Seprator from './resources/seprator.svg';
import LockPrem from './resources/lockPrem.svg';
import LockBackground from './resources/lock-background.svg';
import PlusBlack from './resources/PlusBlack.svg';
import ContactEmail from './resources/ContactEmail.svg';
import ContactPhone from './resources/ContactPhone.svg';
import Login from './resources/login.svg';
import InfoIcon from './resources/info-icon.svg';
import LightbulbIcon from './resources/lightbulb-icon.svg';
import UserIcon from './resources/userIcon.svg';
import AppleLogo from './resources/apple-logo.svg';
import AppleLogoWhite from './resources/apple-logo-white.svg';
import PlayStore from './resources/play-store.svg';
import SearchIconGrey from './resources/search-icon-grey.svg';
import TopLeftQr from './resources/top-left-qr.svg';
import BottomLeftQr from './resources/bottom-left-qr.svg';
import BottomRightQr from './resources/bottom-right-qr.svg';
import TopRightQr from './resources/top-right-qr.svg';
import EmailBg from './resources/email-bg.svg';
import WhiteArrowRight from './resources/white-arrow-right.svg';
import ArrowRight from './resources/arrow-right.svg';
import BrokenLink from './resources/brokenLink.svg';
import RotateLeftGreen from './resources/rotate-left-green.svg';
import info from './resources/info.svg';
import slideLeft from './resources/slide-left.svg';
import slideRight from './resources/slide-right.svg';
import slideLeftDis from './resources/slide-left-dis.svg';
import slideRightDis from './resources/slide-right-dis.svg';
import Quotes from './resources/quotes.svg';
import DiversityLogo from './resources/diversity_logo.svg';
import Calendar from './resources/calendar.svg';
import CalendarWhite from './resources/calendar-white.svg';
import ArrowFilledLeft from './resources/arrow-filled-left.svg';
import ArrowFilledRight from './resources/arrow-filled-right.svg';
import CalendarChecked from './resources/checked-calendar.svg';
import DividerHorizontal from './resources/divider-horizontal.svg';
import DividerVertical from './resources/divider-vertical.svg';
import First from './resources/1-st.svg';
import Second from './resources/2-nd.svg';
import Third from './resources/3-rd.svg';
import WinnerBg from './resources/winner-bg.svg';
import ResumeAttached from './resources/resume-attached.svg';
import Rupee from './resources/rupee.svg';
import RupeeGreen from './resources/rupeeGreen.svg';
import RupeeOrange from './resources/rupeeOrange.svg';
import RupeeWhite from './resources/rupeewhite.svg';
import BannerIcon from './resources/banner-icon.svg';
import HiristCalendar from './resources/calendar-hirist.svg';
import HiristFace2Face from './resources/face2face-hirist.svg';
import HiristTelephonic from './resources/telephonic-hirist.svg';
import HiristVideoCall from './resources/video-call.png';
import infoIcon from './resources/info.svg';
import info2 from './resources/info2.svg';
import Lock from './resources/lock.svg';
import Information from './resources/information.svg';
import DoneIcon from './resources/done-icon.svg';
import CrossHirist from './resources/cross-hirist.svg';
import Right from './resources/right.svg';
import Settings from './resources/setting.svg';
import CheckHirist from './resources/check-hirist.svg';
import BlankTickHirist from './resources/blank-hirist-check.svg';
import LockHirist from './resources/lock-hirist.svg';
import UnlockHirist from './resources/hirist-unlock.svg';
import GolderBar from './resources/goldenBAr.svg';
import analytics from './resources/analytics.svg';
import devops from './resources/devops.svg';
import emergingTech from './resources/emerging-technology.svg';
import enterprise from './resources/enterprise.svg';
import frontendDev from './resources/frontend-developer.svg';
import backendDev from './resources/backend.svg';
import mobileApp from './resources/mobile-applications.svg';
import others from './resources/others.svg';
import HiristDone from './resources/Done-Icon-2.svg';
import product from './resources/product-managment.svg';
import project from './resources/project-managment.svg';
import quality from './resources/quality.svg';
import semiconductor from './resources/semicondutcor.svg';
import uidesign from './resources/ui-design.svg';
import DownloadIcon from './resources/download-app-icon.svg';
import StaticBg from './resources/StaticBg.svg';
import CrossIcon from './resources/cross-icon.svg';
import RightArrow from './resources/right-arrow.svg';
import OrangeRightArrow from './resources/orange-right-arrow.svg';
import Profile from './resources/profile.svg';
import ProfileOrange from './resources/profile-orange.svg';
import ArrowUp from './resources/arrow-up.svg';
import HomeBread from './resources/home-bread.svg';
import HamburgerMenuNew from './resources/hamburger-menu-new.svg';
import aiMl from './resources/new-category-images/ai-ml.webp';
import dataAnalyticsAndBI from './resources/new-category-images/data-analytics-and-bi.webp';
import dataEngineering from './resources/new-category-images/data-engineering.webp';
import backendDevelopment from './resources/new-category-images/backend-development.webp';
import frontendDevelopment from './resources/new-category-images/frontend-development.webp';
import fullStack from './resources/new-category-images/full-stack.webp';
import mobileApplication from './resources/new-category-images/mobile-applications.webp';
import emergingTechnologies from './resources/new-category-images/emerging-technologies.webp';
import devopsSre from './resources/new-category-images/devops-sre.webp';
import cyberSecurity from './resources/new-category-images/cybersecurity.webp';
import qualityAssurance from './resources/new-category-images/quality-assurance.webp';
import platformEngineeringSreOracle from './resources/new-category-images/platform-engineering-sap-oracle.webp';
import Others from './resources/new-category-images/others.webp';
import Product from './resources/new-category-images/product-managment.webp';
import Project from './resources/new-category-images/project-managment.webp';
import UIDesign from './resources/new-category-images/ui-design.webp';
import OrangeLeftArrowCircle from './resources/orange-left-arrow-circle.svg';
import OrangeRightArrowCircle from './resources/orange-right-arrow-circle.svg';
import OrangeTick from './resources/orange-tick.svg';
import CheckOrange from './resources/check-orange.svg';
import ClosedBreifCase from './resources/old-fashion-briefcase.svg';
import LineChart from './resources/line-chart.svg';
import Comment from './resources/comment.svg';
import UserDP from './resources/user-silhouette.svg';
import SavedHirist from './resources/saved-hirist.svg';
import Man from './resources/man.svg';
import OrangeCheckCircle from '././resources/orange-circle.svg';
import OrangeCheckIcon from '././resources/orangeCheckIcon.svg';
import NotificationOld from './resources/notification-old.svg';
import SearchOld from './resources/search-old.svg';
import SearchPill from './resources/search-pill.svg';
import NotifyInterviewInviteFull from './resources/briefcase.svg';
import NotifyIcCheckFull from './resources/notify-check-full.svg';
import BellIcon from './resources/bell-icon.svg';
import NotifyUpdateResumeFull from './resources/notify-update-resume-full.svg';
import NotifyIconPublishedFull from './resources/notify-icon-published-full.svg';
import NotifyVerifyEmailFull from './resources/notify-verify-email-full.svg';
import NotifyVerifyPhoneFull from './resources/notify-verify-phone-full.svg';
import NotifyUnansweredVideo from './resources/notify-unanswered-video.svg';
import Briefcase from './resources/briefcase.svg';
import BannerTick from './resources/banner-tick.svg';
import HiristMail from './resources/hirist-mail.svg';
import HiristTick from './resources/hirist-tick.svg';
import HiristGreenTick from './resources/hirist-green-tick.svg';
import ChevronLeftOrange from './resources/chevron-left-orange.svg';
import FilterMob from './resources/Group-3.svg';
import TermsAndConditionIcon from './resources/term.svg';
import Successful from './resources/Successful icon.svg';
import AIPixel from './resources/AI_Pixel.svg';
import ConfVerified from './resources/confiVerified.svg';
import ConfiTag from './resources/confiTag.svg';
import ConfidentialIcon from './resources/confidential-icon.svg';
import ConfidentialTag from './resources/confidential-tag.svg';
import VerifiedRecruiter from './resources/verified-recruiter.svg';
import ThreeStar from './resources/threeStar.svg';
import EmailCaptureIcon from './resources/email-capture.svg';
import ApplicationStatusBG from './resources/app-status-bg.svg';
import {
  HiristSaveJob,
  HiristArrowDisabled,
  HiristArrowEnabled,
  HiristBriefcase,
  HiristClock,
  HiristOpenBook,
  HiristRupee,
  HiristInfoIcon,
} from './resources/hirist';
import StarHirist from './resources/StarHirist.svg';
import IndianRupee from './resources/rupee-indian.svg';
import RupeeGrey from './resources/rupeegrey.svg';
import Star from './resources/NormalStar.svg';
import BreifCase from './resources/old-fashion-briefcase.svg';
import OpenBook from './resources/open-book.svg';
import SwitchOff from './resources/switchoff.svg';
import RemoveIcon from './resources/remove.svg';
import InformationIcon from './resources/information2.svg';
import HiristResumeAttached from './resources/resume-attachedV2.svg';
import RotateLeftOrange from './resources/rotate-left-orange.svg';
import BlackCrossOutlined from './resources/black-cross-outline.svg';
import HiristRadioSelected from './resources/radio-select-hirist.svg';
import ProductManager from './resources/product.svg';
import Marketing from './resources/marketing.svg';
import CEO from './resources/ceo.svg';
import HRBP from './resources/hrbp.svg';
import Target from './resources/target.svg';
export * from './resources/hirist';
import WhiteInfoIcon from './resources/info-icon-white.svg';
import WhiteChevronDown from './resources/chevron-down-white.svg';
import CheckV2 from './resources/checkv2.svg';
import HiristRefundIcon from './resources/hirist-refund-icon.svg';
import EmailBgOrange from './resources/email-bg-orange.svg';
import StarIconV2 from './resources/star-icon.svg';
import StarIconHirist from './resources/star-icon-hirist.svg';
import GreyDivider from './resources/grey-divider.svg';
import WhiteDivider from './resources/white-divider.svg';
import Email from './resources/email.svg';
import LinkIcon from './resources/link.svg';
import ProfileUpdateInfoIcon from './resources/information-icon.svg';
import HiristDoneIcon from './resources/hirist-done-icon.svg';
import IImjobsDoneIcon from './resources/iimjobs-done-icon.svg';
import IImjobsProfileUpdateInfoIcon from './resources/iimjobs-information-icon.svg';
import FourHStar from './resources/4.5-star.svg';
import ThreStar from './resources/3-star.png';
import ThreeHStar from './resources/3.5-star.png';
import FiveStar from './resources/5-star.png';
import FourStar from './resources/4-star.png';
import ReviewsUserIcon from './resources/branded-jd-user.svg';
import LineSeparator from './resources/line-separator.svg';
import VerifiedIcon from './resources/verified-icon.svg';
import NextV from './resources/nextV.svg';
import PrevV from './resources/prevV.svg';
import openHir from './resources/openHir.svg';
import NextVDIs from './resources/nextVDis.svg';
import PlayButton from './resources/playButton.svg';
import openIIm from './resources/openIIm.svg';
import ChevronUpDark from './resources/chevronUp.svg';
import ChevronDownDark from './resources/chevronDown.svg';
import Failed from './resources/failed.svg';
import HiristDot from './resources/hirist-dot.svg';
import SurveyOptionUnselected from './resources/survey-option-unselected.svg';
import SurveyOptionSelected from './resources/survey-option-selected.svg';
import WinnerBg2 from './resources/winner-bg2.svg';
import TopStar from './resources/topStar.svg';
import TopRecrBadge3 from './resources/TopRecrBadge3.svg';
import TopRecrBadge5 from './resources/TopRecrBadge5.svg';
import TopRecrBadge5p from './resources/TopRecrBadge5p.svg';
import TopRecrBadge10 from './resources/TopRecrBadge10.svg';
import TopRecrBadge10p from './resources/TopRecrBadge10p.svg';
import ImprovementsHirist from './resources/improvements-hirist.svg';
import UploadHirist from './resources/upload-hirist.svg';
import HiristTrash from './resources/hirist-trash.svg';
import HiristViewIcon from './resources/hirist-view.svg';
import Resume from './resources/resume.svg';
import circularTick from './resources/circularTick.svg';
import Thunder from './resources/thunder.svg';
import BadgeTick from './resources/badgeTick.svg';
import Cal from './resources/cal.svg';
import Prem from './resources/prem.svg';
import CVAnalyserCheckIcon from './resources/cv-analyser-check-icon.svg';
import EmailNotificationIcon from './resources/email-notification.svg';
import PushNotificationIcon from './resources/push-notification.svg';
import ResumeIcon from './resources/resumeIcon.svg';
import UploadIIMJobs from './resources/upload-iimjobs.svg';
import WhatsApp from './resources/whatsapp.svg';
import RectangleMoney from './resources/rectangle-money.svg';
import TalentBridgeBriefcaseIcon from './resources/talent-bridge-briefcase-icon.png';
import TalentBridgeCalendarIcon from './resources/talent-bridge-calendar-icon.png';
import TalentBridgeHeroBg from './resources/talent-bridge-hero-bg.png';
import TalentBridgeIllustration from './resources/htb-illus.svg';
import TalentBridgeLogo from './resources/talent-bridge-logo.svg';
import TalentBridgeMapIcon from './resources/talent-bridge-map-icon.png';
import TalentBridgeTargetIcon from './resources/talent-bridge-target-icon.png';
import TalentBridgeTicketIcon from './resources/talent-bridge-ticket-icon.png';
import TalentBridgeShortlistedCheckIcon from './resources/talent-bridge-shortlisted-check-icon.png';
const SemiConductor = aiMl; // same icon for both categories
export {
  LightbulbIcon,
  ResumeIcon,
  circularTick,
  Thunder,
  BadgeTick,
  Cal,
  Prem,
  CheckedOrange,
  Briefcase,
  NotifyInterviewInviteFull,
  NotifyIcCheckFull,
  BellIcon,
  NotifyUpdateResumeFull,
  NotifyIconPublishedFull,
  NotifyVerifyEmailFull,
  NotifyVerifyPhoneFull,
  NotifyUnansweredVideo,
  aiMl,
  dataAnalyticsAndBI,
  dataEngineering,
  backendDevelopment,
  frontendDevelopment,
  fullStack,
  mobileApplication,
  emergingTechnologies,
  devopsSre,
  cyberSecurity,
  qualityAssurance,
  platformEngineeringSreOracle,
  audio,
  video,
  Lock,
  videoOverlayIcon,
  CheckCircle,
  Calender,
  Categorize,
  CrossWhite,
  LeftArrow,
  info2,
  CheckIcon,
  UnCheckIcon,
  FourHStar,
  FourStar,
  ThreStar,
  ThreeHStar,
  FiveStar,
  Eye,
  HiddenEye,
  Video,
  Send,
  CrossOutlined,
  Docs,
  slideLeft,
  slideRight,
  slideLeftDis,
  slideRightDis,
  Women,
  WomenProfessional,
  DifferentlyAbled,
  Medal,
  ThreeStar,
  Home,
  Man,
  NextV,
  PrevV,
  NextVDIs,
  Cross,
  YellowCrown,
  Users,
  DefaultJobLogo,
  LineDivider,
  ChevronUp,
  ChevronDown,
  ChevronDownLight,
  ChevronRight,
  WhiteCrossOutlined,
  ChevronLeft,
  Filter,
  Search,
  Check,
  HamburgerMenu,
  Logout,
  Notification,
  Message,
  Edit,
  HashTag,
  EmptyJob,
  ThumbUp,
  infoIcon,
  DrawerClose,
  Dot,
  BankingFinanceJobs,
  AIJobs,
  SalesMarketingJobs,
  ConsultingJobs,
  RoundedStar,
  HRIRJobs,
  ITSystemJobs,
  TickBox,
  Download,
  HiristDownload,
  SCMOperationJobs,
  LegalJobs,
  BPOJobs,
  HiristDone,
  SearchIcon,
  GoUpIcon,
  CautionIcon,
  ThreeDotMenuIcon,
  StarIcon,
  RadioSelected,
  RadioUnSelected,
  NoNotificationBanner,
  IimjobsLogo,
  IimjobsLogoOutlined,
  WebBrowserLogo,
  Survey,
  SurveyBackground,
  SearchIconGrey,
  SurveyCheck,
  ThumbsUpYellow,
  ThumbsDownGrey,
  CrossOutlineWhite,
  AddOutlineBlack,
  GreenBag,
  SurveyCheckGreen,
  ThumbsUpGreen,
  OutlineCicleCheck,
  OutlineCircleCross,
  WrongCircle,
  CheckedHirist,
  NoJobSaved,
  LinkedIn,
  Facebook,
  Twitter,
  Minus,
  Plus,
  Mumbai,
  Bengaluru,
  Chennai,
  DelhiNCR,
  Hyderabad,
  Kolkata,
  Pune,
  WhiteChevronRight,
  MinusBlack,
  PlusBlack,
  ContactEmail,
  Scope,
  Seprator,
  HiristMan,
  HiristWoman,
  ContactPhone,
  Login,
  DownloadIcon,
  InfoIcon,
  UserIcon,
  AppleLogo,
  AppleLogoWhite,
  PlayStore,
  TopLeftQr,
  TopRightQr,
  BottomLeftQr,
  BottomRightQr,
  FilterMob,
  EmailBg,
  ArrowRight,
  WhiteArrowRight,
  BrokenLink,
  RotateLeftGreen,
  info,
  Quotes,
  DiversityLogo,
  LockPrem,
  LockBackground,
  Calendar,
  CalendarWhite,
  ArrowFilledLeft,
  ArrowFilledRight,
  CalendarChecked,
  DividerHorizontal,
  DividerVertical,
  First,
  Second,
  Third,
  WinnerBg,
  ResumeAttached,
  Rupee,
  RupeeGreen,
  RupeeOrange,
  RupeeWhite,
  BannerIcon,
  HiristCalendar,
  HiristFace2Face,
  HiristTelephonic,
  HiristVideoCall,
  Information,
  DoneIcon,
  CrossHirist,
  Right,
  Settings,
  CheckHirist,
  BlankTickHirist,
  LockHirist,
  UnlockHirist,
  analytics,
  devops,
  backendDev,
  frontendDev,
  project,
  StaticBg,
  product,
  emergingTech,
  semiconductor,
  uidesign,
  BgImage,
  mobileApp,
  others,
  Thread,
  enterprise,
  quality,
  HTick,
  CrossIcon,
  RightArrow,
  OrangeRightArrow,
  GolderBar,
  Profile,
  ProfileOrange,
  ArrowUp,
  HomeBread,
  HamburgerMenuNew,
  Others,
  Product,
  Project,
  SemiConductor,
  UIDesign,
  OrangeLeftArrowCircle,
  OrangeRightArrowCircle,
  OrangeTick,
  CheckOrange,
  UserDP,
  ClosedBreifCase,
  Comment,
  LineChart,
  SavedHirist,
  OrangeCheckCircle,
  OrangeCheckIcon,
  NotificationOld,
  SearchOld,
  SearchPill,
  BannerTick,
  HiristGreenTick,
  HiristMail,
  HiristTick,
  HiristSaveJob,
  StarHirist,
  HiristArrowEnabled,
  HiristArrowDisabled,
  IndianRupee,
  RupeeGrey,
  OpenBook,
  BreifCase,
  Star,
  SwitchOff,
  RemoveIcon,
  InformationIcon,
  HiristBriefcase,
  HiristClock,
  HiristOpenBook,
  HiristRupee,
  HiristInfoIcon,
  HiristResumeAttached,
  RotateLeftOrange,
  ChevronLeftOrange,
  BlackCrossOutlined,
  HiristRadioSelected,
  WhiteInfoIcon,
  WhiteChevronDown,
  CheckV2,
  TermsAndConditionIcon,
  HiristRefundIcon,
  EmailBgOrange,
  StarIconV2,
  GreyDivider,
  Email,
  LinkIcon,
  ProfileUpdateInfoIcon,
  HiristDoneIcon,
  Successful,
  IImjobsDoneIcon,
  IImjobsProfileUpdateInfoIcon,
  AIPixel,
  ConfVerified,
  ConfiTag,
  ConfidentialIcon,
  ConfidentialTag,
  VerifiedRecruiter,
  StarIconHirist,
  WhiteDivider,
  ReviewsUserIcon,
  LineSeparator,
  VerifiedIcon,
  ChevronDownDark,
  ChevronUpDark,
  PlayButton,
  openIIm,
  openHir,
  Failed,
  ProductManager,
  Marketing,
  CEO,
  HRBP,
  Target,
  HiristDot,
  SurveyOptionUnselected,
  SurveyOptionSelected,
  WinnerBg2,
  EmailCaptureIcon,
  TopStar,
  TopRecrBadge3,
  TopRecrBadge5,
  TopRecrBadge5p,
  TopRecrBadge10,
  TopRecrBadge10p,
  ImprovementsHirist,
  UploadHirist,
  HiristTrash,
  HiristViewIcon,
  Resume,
  ApplicationStatusBG,
  CVAnalyserCheckIcon,
  EmailNotificationIcon,
  PushNotificationIcon,
  UploadIIMJobs,
  WhatsApp,
  RectangleMoney,
  TalentBridgeBriefcaseIcon,
  TalentBridgeCalendarIcon,
  TalentBridgeHeroBg,
  TalentBridgeIllustration,
  TalentBridgeLogo,
  TalentBridgeMapIcon,
  TalentBridgeTargetIcon,
  TalentBridgeTicketIcon,
  TalentBridgeShortlistedCheckIcon,
  IconQuickApplyLocation,
  IconQuickApplyExperience,
  IconQuickApplyLightningOrange,
  IconQuickApplyLightningWhite,
  IconQuickApplySend,
  IconQuickApplyLock,
  IconQuickApplyCheckCircle,
  IconQuickApplySearch,
  IconQuickApplyArrowRight,
  IconQuickApplyEye,
  IconQuickApplyStar,
  IconQuickApplyCheck,
  IconQuickApplyPerson,
  IconQuickApplyCompany,
  IconCallConsentBoth,
  IconCallConsentTick,
  IconQuickApplyDesignation,
  IconQuickApplyCalendar,
  IconQuickApplyRupee,
  IconQuickApplyAboutRole,
  IconQuickApplyResponsibilities,
  IconQuickApplyQualifications,
  IconQuickApplyPreferred,
  IconQuickApplyLightningGreen,
  IconQuickApplyEyeGreen,
  IconQuickApplyStarGreen,
};
